@file:OptIn(ExperimentalResourceApi::class)

package ui.company

import androidx.compose.runtime.*
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import common.frontend.api.Io
import org.jetbrains.compose.resources.ExperimentalResourceApi
import provider.LocalAccountProvider
import ssoft.frontend.generated.resources.*
import tk.mallumo.compose.navigation.LocalNavigation
import tk.mallumo.compose.navigation.Navigation
import tk.mallumo.compose.navigation.viewmodel.globalViewModel
import tk.mallumo.compose.navigation.viewmodel.viewModel
import tools.EFieldList
import tools.EFieldTextString
import ui.GlobalVM
import ui.widget.ListingSpecs


interface CompanyListingScope {

    val vmGlobal: GlobalVM
    val vm: CompanyListingVM
    val nav: Navigation
    val login: Io.User
    val action: (CompanyListingVM.Action) -> Unit

    companion object {
        val headerSpecs = ListingSpecs.create<Wrapper.Item>(
            ListingSpecs.Item(title = Res.string.company_listing__item_id, width = 50.dp, align = TextAlign.Center) { ListingSpecs.trimmedId(it.data.id) },
            ListingSpecs.Item(title = Res.string.company_listing__item_name, width = 200.dp) { it.data.name },
            ListingSpecs.Item(title = Res.string.company_listing__item_users, width = 80.dp) { it.data.count_user },
            ListingSpecs.Item(title = Res.string.company_listing__item_devices, width = 80.dp) { it.data.count_device },
            ListingSpecs.Item(title = Res.string.company_listing__item_locations, width = 80.dp) { it.data.count_location },
        )

        @Composable
        fun rememberScope(): CompanyListingScope {
            val nav = LocalNavigation.current
            val account = LocalAccountProvider.current
            val vm = nav.viewModel(CompanyListingVM::class)
            val vmGlobal = globalViewModel(GlobalVM::class)
            val action = CompanyListingVM.Action.rememberAction(vm)
            return remember {
                object : CompanyListingScope {
                    override val vmGlobal: GlobalVM
                        get() = vmGlobal
                    override val vm: CompanyListingVM
                        get() = vm
                    override val nav: Navigation
                        get() = nav
                    override val login: Io.User
                        get() = account.current!!
                    override val action: (CompanyListingVM.Action) -> Unit
                        get() = action


                }.also {
                    vm.init(it)
                }
            }
        }
    }

    class Wrapper(
        val canAdd: Boolean,
        listing: Io.ListingCompany
    ) : EFieldList<Io.ListingCompany.Item, Wrapper.Item>(
        items = listing.items,
        onBindEntry = { Item(it) }
    ) {
        class Item(
            override val data: Io.ListingCompany.Item,
            override val key: String = data.id.toString()
        ) : Entry<Io.ListingCompany.Item> {
            private var origin = data.copy()

            val name: EFieldTextString = EFieldTextString(
                property = data::name,
                condition = { it.trim().takeIf { it.isNotEmpty() } },
                onChange = { makeChange() },
                onErr = { makeChange() })

            var change by mutableStateOf(false)
                private set

            private fun makeChange() {
                change = when {
                    name.err -> false
                    origin.name != data.name -> true
                    else -> false
                }
            }
        }
    }
}
